module.exports = __webpack_public_path__ + "media/images/icons/green-check-icon-117e0058adcac6d10b194857539655e9.svg";